module.exports = __webpack_public_path__ + "img/Poker-new.c3d5286.png";